var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center w-100 my-5"},[_c('img',{staticClass:"m-auto d-inline-block custom-loader-image",attrs:{"src":"/img/SLMath/SLMathLoader.gif"}})])
}]

export { render, staticRenderFns }